import { BASE_URL, MERCHANT_UI_URL } from '@/config';

const DASHBOARD_PATHS = {
  MERCHANT: MERCHANT_UI_URL + '/dashboard/',
  CLIENT: BASE_URL + '/shopper/',
} as const;

export const getDashboardUrl = (role: string | undefined): string =>
  DASHBOARD_PATHS[role as keyof typeof DASHBOARD_PATHS] ?? DASHBOARD_PATHS.CLIENT;
